import { Link } from "react-router-dom";
import { useSeo } from "@/lib/shop";

export default function NotFound() {
  useSeo("Halaman tidak ditemukan");
  return (
    <section className="container-x py-20 text-center" data-testid="not-found-page">
      <div className="inline-block sticker rounded-3xl bg-[var(--bk-yellow)] halftone px-10 py-8 rotate-[-2deg]">
        <div className="font-display text-7xl sm:text-8xl">404</div>
      </div>
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold mt-8">Waduh, halamannya tidak ketemu!</h1>
      <p className="text-neutral-600 mt-3 max-w-md mx-auto">Mungkin tautannya salah atau produknya sudah tidak tersedia. Yuk lanjut berburu koleksi.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="btn-brand" data-testid="notfound-home-btn">Kembali ke Beranda</Link>
        <Link to="/katalog" className="btn-ink" data-testid="notfound-catalog-btn">Lihat Katalog</Link>
      </div>
    </section>
  );
}
